import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import Community from '../components/agora/Community';
import DebateArena from '../components/agora/DebateArena';

const AgoraPage = () => {
  const [activeTab, setActiveTab] = useState('debates');

  const tabs = [
    { key: 'debates', label: 'Debates' },
    { key: 'community', label: 'Symposiums' },
  ];

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-serif font-bold text-white">
            The Agora
          </h1>
          <div className="flex space-x-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  activeTab === tab.key
                    ? 'bg-oliveGold text-white'
                    : 'text-white/60 hover:text-white hover:bg-white/5'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'community' ? (
          <Community />
        ) : (
          <DebateArena />
        )}
      </div>
    </Layout>
  );
};

export default AgoraPage;
